import { useCallback, useRef, FC } from 'react';

import { HSpacingContainer } from '@hh.ru/magritte-ui';

import RangeInput from 'src/components/Search/Resume/Filters/FilterWithChart/Input';
import { FilterRangeTrls } from 'src/components/Search/Resume/Filters/FilterWithChart/types';
import { ClusterKey, Range, RangeClusterSelectedValues } from 'src/types/search/common/clusters';

interface InputsGroupProps {
    name: typeof ClusterKey.Salary | typeof ClusterKey.Age;
    values: RangeClusterSelectedValues;
    applyFilter: (data: RangeClusterSelectedValues) => void;
    trls: FilterRangeTrls;
}

const InputsGroup: FC<InputsGroupProps> = ({ values, applyFilter, name, trls }) => {
    const fromInputRef = useRef<HTMLInputElement>(null);
    const toInputRef = useRef<HTMLInputElement>(null);

    const onSubmit = useCallback(
        (stringValue: string, scope: Range) => {
            const value = stringValue ? Number(stringValue) : null;
            if (values[scope] !== value) {
                applyFilter({ ...values, [scope]: value });
            }
        },
        [applyFilter, values]
    );

    return (
        <HSpacingContainer default={12}>
            <RangeInput
                name={name}
                value={(values[Range.From] || '').toString()}
                scope={Range.From}
                label={trls.labelFrom}
                onSubmit={onSubmit}
                inputRef={fromInputRef}
            />
            <RangeInput
                name={name}
                value={(values[Range.To] || '').toString()}
                scope={Range.To}
                label={trls.labelTo}
                onSubmit={onSubmit}
                inputRef={toInputRef}
            />
        </HSpacingContainer>
    );
};

export default InputsGroup;
